import LoginForm from "../auth/LoginForm";

const Login = () => (
  <div className="flex justify-center items-center min-h-screen bg-gray-100">
    <LoginForm />
  </div>
);

export default Login;
